// Get version from package.json
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;

// Format version for display
export const getFormattedVersion = () => {
  return `v${APP_VERSION}`;
};

export default APP_VERSION; 